import React from 'react';
import Top from './FixedBar';
import { days, getDaysInMonth, monthsFull } from './helper';
import { CloseIcon } from '../../styles/icons/svg';
import './Calendar.scss';

const Calendar = ({ selectedDate, onClose, numOfMons = 2, onSel }) => {

    const renderData = [];
    const today = new Date();
    const month = today.getMonth();
    
    let weeks = [...days];
    weeks.push(weeks.shift());

    for (let i = 0; i < numOfMons; i++) {
        renderData.push({
            month: month + i > 11 ? month + i - 12 : month + i,
            year: month + i > 11 ? today.getFullYear() + 1 : today.getFullYear(),
            days: getDaysInMonth(
                month + i > 11 ? month + i - 12 : month + i,
                month + i > 11 ? today.getFullYear() + 1 : today.getFullYear(),
                -1
            )
        })
    }

    const sel = (date, month, year) => {
        const dt = new Date(`${year}-${month + 1}-${date}`);
        onSel(dt);
    }

    return (
        <React.Fragment>
            <Top className='cal--header' style={{ backgroundColor: '#1e59a7' }}>
                <div className='cal--header-top'>
                    <div className='cal--header-top-close' onClick={onClose}><CloseIcon /></div>
                    <div>Services Due On</div>
                </div>
                <div className='cal--header-weeks'>
                    {
                        weeks.map(el => <div key={el} className='cal--header-weeks-text'>{el}</div>)
                    }
                </div>
            </Top>
            <div className='cal--content'>
                {
                    renderData.map(item => (
                        <div className='cal--content-wrapper' key={item.month}>
                            <div className='cal--content-wrapper-month'>{`${monthsFull[item.month]} ${item.year}`}</div>
                            <div className='cal--content-wrapper-days'>
                                {item.days.map((el, index) => renderDates(index, el, item.month, item.year, new Date(selectedDate), sel))}
                            </div>
                        </div>
                    ))
                }
            </div>
        </React.Fragment>
    )
}

const renderDates = (key, date, month, year, sel, selectDate) => {
    const curr = new Date();
    const isSelected = date === sel.getDate() && month === sel.getMonth();// && year === sel.getFullYear();
    const isPrevDate = month === curr.getMonth() && date < curr.getDate() - 1;
    const isWeekend = [5, 6, 12, 13, 19, 20, 26, 27, 33, 34].indexOf(key) > -1;
    
    let maxDate = new Date();
    maxDate.setDate(maxDate.getDate() + 30);
    
    const isFutureDate = month >=maxDate.getMonth() && date > maxDate.getDate();
  
    return (
        <div key={key} className={`${(isPrevDate || isFutureDate )? 'cal--content-wrapper-days-disabled' : ''} ${isWeekend && 'cal--content-wrapper-days-weekend'}`}>
            <div
                onClick={() => selectDate(date, month, year)}
                className={`${isSelected ? 'cal--content-wrapper-days-sel' : ''}`}
                style={isSelected ? { backgroundColor: '#1e59a7' } : {}}
            >
                {date}
            </div>
        </div >
    )
}

export default Calendar;